import { apolloClient } from '~/apollo-client';
import { ParsedQueryParams } from '~/providers/query-params/types';
import { CREATE_PROSPECT_USER } from './create-prospect-user.queries';

export interface CreateProspectUserInput {
  utilityId: number;
  zipCode: string;
  firstName: string;
  lastName: string;
  phone?: string;
  email: string;
  queryParams?: ParsedQueryParams;
  funnel?: string;
}

export interface CreateProspectUserResponse {
  id: number;
  utilityId: number;
  zipcode: string;
  firstName: string;
  lastName: string;
  phone?: string;
  email: string;
}

export const createProspectUser = async (
  input: CreateProspectUserInput,
): Promise<CreateProspectUserResponse> => {
  const response = await apolloClient.mutate({
    mutation: CREATE_PROSPECT_USER,
    variables: { input },
  });

  if (!response.data?.createProspectUser) {
    throw new Error('Failed to create prospect user');
  }

  return response.data.createProspectUser;
};
